module.exports = __webpack_public_path__ + "static/scale-model-of-memphis-rock-'n'-soul-museum-in-memphis-tennessee-3caa15fe76be1760478cb992e91988e8.png";